import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Grid } from '@mui/joy';
import ActionButton from '../../../../Components/custom_components/CustomButtons/ActionButton/ActionButton';
import './CertificationForm.css'; // Updated for CertificationForm
import CustomTextFieldWithIcon from '../../../../Components/custom_components/custom_text_field/CustomTextFieldWithIcon';
import { TbFileDescription } from 'react-icons/tb';
import CustomTextArea from '../../../../Components/custom_components/CustomTextArea/CustomTextArea';
import CustomSelectDropdown from '../../../../Components/custom_components/CustomSelectDropdown/CustomSelectDropdown';
import { statusOptions } from '../../../../utils/constants';

function CertificationForm({ handleSave, isButtonDisabled, formIntialValues, id }) {

    const formik = useFormik({
        initialValues: formIntialValues, // Set initial values directly from props
        validationSchema: Yup.object({
            Name: Yup.string().required('Skill name is required'),
            status: Yup.string().required('Status is required'),
        }),
        enableReinitialize: true, // Enable re-initialization of form values when props change
        onSubmit: (values) => {
            handleSave(values, id);
        },
    });

    // Reset handler
    const handleReset = () => {
        formik.setFieldValue('status', 1);
        formik.setFieldValue('Name', '');
        formik.setFieldValue('Description', '');
        // Reset warning messages
        formik.setTouched({
            Name: false,
            status: false,
            Description: false
        });
    };

    return (
        <div className='certification-form-container'>
            {/* FORM START */}
            <Grid container spacing={2}>
                {/* LEFT SIDE */}
                <Grid item xs={12} md={6}>
                    <div className='certification-form-mid-container'>
                        <div className='certification-label-container'>
                            <span className='certification-label'>
                                Category Name <span className='certification-required-remark'>*</span>
                            </span>
                        </div>
                        <div className='certification-custom-textfield-container'>
                            <CustomTextFieldWithIcon
                                id='Name'
                                name='Name'
                                placeholder='Enter Category Name'
                                value={formik?.values?.Name}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.Name && Boolean(formik.errors.Name)}
                                helperText={formik.touched.Name && formik.errors.Name}
                            />
                        </div>
                    </div>
                </Grid>

                {/* RIGHT SIDE */}
                {id && <Grid item xs={12} md={6}>
                    <div className='certification-form-mid-container'>
                        <div className='certification-label-container'>
                            <span className='certification-label'>
                                Status <span className='certification-required-remark'>*</span>
                            </span>
                        </div>
                        <div className='certification-custom-textfield-container'>
                            <CustomSelectDropdown
                                name="status"
                                placeholder="Select Status"
                                options={statusOptions}
                                value={statusOptions?.find(option => option?.value === formik?.values?.status) || ""}
                                onChange={(selectedOption) => {
                                    formik.setFieldValue("status", selectedOption ? selectedOption.value : "");
                                }}
                                onBlur={formik.handleBlur}
                                error={formik.touched.status && Boolean(formik.errors.status)}
                                helperText={formik.touched.status && formik.errors.status}
                                isClearable={false} // Set to false for single-select
                                width="100%"
                            />
                        </div>
                    </div>
                </Grid>
                }
                <Grid item xs={12} md={6}>
                    {/* RoleDescription */}
                    <div className="certification-label-container">
                        <span className="certification-label">Description<span className='certification-label_required_remark'></span></span>
                    </div>
                    <div className="certification-custom-textfield-container">
                        <CustomTextArea
                            id="Description"
                            name="Description"
                            placeholder="Enter Description"
                            value={formik.values.Description}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            rows={5}
                            StartIcon={TbFileDescription}
                        />
                    </div>
                </Grid>

            </Grid>

            <div className='certification-form-bottom-buttons-container'>
                <ActionButton onClick={handleReset} label='Reset' btnType='outlined' />
                <ActionButton
                    onClick={() => formik.handleSubmit()}
                    btnDisable={isButtonDisabled}
                    label='Save'
                    btnType='primary'
                />
            </div>
        </div>
    );
}

export default CertificationForm;
